import { baseStates, baseMutations, baseActions, baseGetters } from '@/stores/base';

export const companyExpenseActivity = {

    namespaced: true,

    state:
    {
        ...baseStates,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters
    },
};
